import Vue from 'vue'
import NuxtLoading from './components/nuxt-loading.vue'

import '../app/assets/stylesheets/medium-editor.scss'

import '../app/assets/stylesheets/vuex-toast.scss'

import '../node_modules/@alisproject/alis-editor/dist/AlisEditor.css'

import '../app/assets/stylesheets/ckeditor-view.scss'

import _6f6c098b from '../app/layouts/default.vue'

const layouts = { "_default": _6f6c098b }

export default {
  head: {"script":[{"src":"\u002F\u002Fcdn.iframe.ly\u002Fembed.js?api_key=518401c27d170fda5a9fbc&omit_script=1","async":true},{"src":"\u002F\u002Fcdn.jsdelivr.net\u002Fgh\u002Fethereum\u002Fweb3.js@1.0.0-beta.34\u002Fdist\u002Fweb3.min.js","defer":true}],"title":"ALIS | 信頼できる記事と人々を明らかにする全く新しいソーシャルメディア","titleTemplate":"%s | ALIS","meta":[{"charset":"utf-8"},{"hid":"viewport","name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"apple-mobile-web-app-title","content":"ALIS"},{"hid":"description","name":"description","content":"ALIS is Japan's First Social Media Using Blockchain Technology"},{"hid":"og:title","property":"og:title","content":"ALIS | 信頼できる記事と人々を明らかにする全く新しいソーシャルメディア"},{"hid":"og:description","property":"og:description","content":"ALIS is Japan's First Social Media Using Blockchain Technology"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fyasudev.alis-test.tk\u002Fd\u002Fnuxt\u002Fdist\u002FOGP_1200×630.png"},{"hid":"twitter:card","name":"twitter:card","content":"summary_large_image"},{"hid":"twitter:site","name":"twitter:site","content":"@ALIS_media"},{"hid":"twitter:image","name":"twitter:image","content":"https:\u002F\u002Fyasudev.alis-test.tk\u002Fd\u002Fnuxt\u002Fdist\u002FOGP_1200×630.png"},{"hid":"fb:app_id","property":"fb:app_id","content":"2157199921164241"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"https:\u002F\u002Fyasudev.alis-test.tk\u002Fd\u002Fnuxt\u002Fdist\u002Ffavicon.ico"},{"rel":"apple-touch-icon","sizes":"192x192","href":"https:\u002F\u002Fyasudev.alis-test.tk\u002Fd\u002Fnuxt\u002Fdist\u002Ftouch-icon.png"},{"rel":"shortcut icon","href":"https:\u002F\u002Fyasudev.alis-test.tk\u002Fd\u002Fnuxt\u002Fdist\u002Ftouch-icon.png"},{"rel":"stylesheet","href":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fajax\u002Flibs\u002Ffont-awesome\u002F5.9.0\u002Fcss\u002Fall.min.css"}],"style":[]},

  render(h, props) {
    const loadingEl = h('NuxtLoading', { ref: 'loading' })
    const layoutEl = h(this.layout || 'nuxt')
    const templateEl = h('div', {
      domProps: {
        id: '__layout'
      },
      key: this.layoutName
    }, [ layoutEl ])

    const transitionEl = h('transition', {
      props: {
        name: 'layout',
        mode: 'out-in'
      },
      on: {
        beforeEnter(el) {
          // Ensure to trigger scroll event after calling scrollBehavior
          window.$nuxt.$nextTick(() => {
            window.$nuxt.$emit('triggerScroll')
          })
        }
      }
    }, [ templateEl ])

    return h('div', {
      domProps: {
        id: '__nuxt'
      }
    }, [loadingEl, transitionEl])
  },
  data: () => ({
    isOnline: true,
    layout: null,
    layoutName: ''
  }),
  beforeCreate() {
    Vue.util.defineReactive(this, 'nuxt', this.$options.nuxt)
  },
  created() {
    // Add this.$nuxt in child instances
    Vue.prototype.$nuxt = this
    // add to window so we can listen when ready
    if (process.client) {
      window.$nuxt = this
      this.refreshOnlineStatus()
      // Setup the listeners
      window.addEventListener('online', this.refreshOnlineStatus)
      window.addEventListener('offline', this.refreshOnlineStatus)
    }
    // Add $nuxt.error()
    this.error = this.nuxt.error
  },

  mounted() {
    this.$loading = this.$refs.loading
  },
  watch: {
    'nuxt.err': 'errorChanged'
  },

  computed: {
    isOffline() {
      return !this.isOnline
    }
  },
  methods: {
    refreshOnlineStatus() {
      if (process.client) {
        if (typeof window.navigator.onLine === 'undefined') {
          // If the browser doesn't support connection status reports
          // assume that we are online because most apps' only react
          // when they now that the connection has been interrupted
          this.isOnline = true
        } else {
          this.isOnline = window.navigator.onLine
        }
      }
    },

    errorChanged() {
      if (this.nuxt.err && this.$loading) {
        if (this.$loading.fail) this.$loading.fail()
        if (this.$loading.finish) this.$loading.finish()
      }
    },

    setLayout(layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default'
      }
      this.layoutName = layout
      this.layout = layouts['_' + layout]
      return this.layout
    },
    loadLayout(layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default'
      }
      return Promise.resolve(layouts['_' + layout])
    }
  },
  components: {
    NuxtLoading
  }
}
